import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'
import { CHART_PALETTE } from '@/lib/chart-theme'
import { StatCard, fmt$, InfoTooltip } from './shared'

const RADIAN = Math.PI / 180

function renderLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) {
  if (percent < 0.05) return null
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)
  return (
    <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central"
      fontSize={12} fontWeight={600}>
      {(percent * 100).toFixed(0)}%
    </text>
  )
}

export function RevenueTypeReport({ data }: { data: any }) {
  const summary = data?.summary || {}
  const chartData = data?.chartData || {}
  const byType = chartData.byType || []
  const totalRevenue = summary.totalRevenue || 0

  return (
    <div className="rep-report">
      <div className="rep-stats-row">
        <StatCard title="Total Signed Revenue" value={fmt$(totalRevenue)} color={CHART_PALETTE[0]} />
        <StatCard title="Project Types" value={summary.projectTypeCount || 0} color={CHART_PALETTE[1]} />
      </div>

      <div className="rep-charts-row">
        <div className="rep-chart-card rep-chart-full">
          <InfoTooltip text="A donut chart highlights each project type's share of total revenue — the proportional breakdown is immediately clear, unlike bars which emphasize absolute values." />
          <div style={{ position: 'relative' }}>
            <ResponsiveContainer width="100%" height={420}>
              <PieChart>
                <Pie data={byType} cx="50%" cy="50%" labelLine={false} label={renderLabel}
                  outerRadius={170} innerRadius={100} dataKey="revenue" stroke="none">
                  {byType.map((_: any, i: number) => (
                    <Cell key={i} fill={CHART_PALETTE[i % CHART_PALETTE.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            {/* Center label */}
            <div className="rep-donut-center">
              <span className="rep-donut-center-value">{fmt$(totalRevenue)}</span>
              <span className="rep-donut-center-label">Total</span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="rep-area-legend" style={{ marginTop: 16 }}>
            {byType.map((item: any, idx: number) => (
              <span className="rep-area-legend-item" key={idx}>
                <span className="rep-area-legend-dot" style={{ background: CHART_PALETTE[idx % CHART_PALETTE.length] }} />
                {item.label} — {fmt$(item.revenue)}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="rep-table-card">
        <h3 className="rep-chart-title">Project Type Breakdown</h3>
        <table className="rep-table">
          <thead><tr><th>Project Type</th><th>Revenue</th><th>% of Total</th></tr></thead>
          <tbody>
            {byType.map((item: any, idx: number) => (
              <tr key={idx}>
                <td>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: CHART_PALETTE[idx % CHART_PALETTE.length], flexShrink: 0 }} />
                    {item.label}
                  </span>
                </td>
                <td>{fmt$(item.revenue)}</td>
                <td>{totalRevenue > 0 ? ((item.revenue / totalRevenue) * 100).toFixed(1) : '0'}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
